export default "__VITE_ASSET__jlqXfeVf__"